import React from "react";
import TextField from "@material-ui/core/TextField";
import Input from "./Input";
import DatePicker from "./DatePicker";
import CheckBox from "./CheckBox";
import RadioButton from "./RadioButton";
import Switchs from "./Switchs";
import AutocompleteList from "./AutocompleteList";
// import InputStates from "./Auto";
// import AutoTest from "./AutoTest";
import SelectList from "./SelectList";
import Grid from "./Grid";

function FormikControl(props) {
  const { control, ...rest } = props;
  switch (control) {
    case "input":
      return <Input {...rest} />;
    case "date":
      return <DatePicker {...rest} />;
    case "checkbox":
      return <CheckBox {...rest} />;
    case "radio":
      return <RadioButton {...rest} />;
    case "switch":
      return <Switchs {...rest} />;
    case "autocompletelist":
      return <AutocompleteList {...rest} />;
    // case "auto":
    // return <InputStates {...rest} />;
    // case "auto":
    //   return <AutoTest {...rest} />;
    case "selectlist":
      return <SelectList {...rest} />;
    case "grid":
      return <Grid {...rest} />;
    default:
      return null;
  }
}
export default FormikControl;
